import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

import { FormFieldLabelStyles } from '@/components/form/model/FormFieldLabel.styles.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

interface Props {
  isRequired: boolean;
  label: string;
  sx?: SxProps<Theme>;
}

export const FormFieldLabel: React.FC<Props> = props => {
  const { isRequired, label, sx } = props;

  return (
    <>
      <Box sx={[FormFieldLabelStyles, ...(Array.isArray(sx) ? sx : [sx])]}>
        {label}
        {isRequired && (
          <Box component="span" sx={{ color: themeColors.red }}>
            *
          </Box>
        )}
      </Box>
    </>
  );
};
